import React, { useEffect, useState } from "react";
import InstagramItem from "./InstagramItem";
import { useSelector } from "react-redux";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";

const InstagramItemNewTab = () => {
    const [currentInstaPost, setCurrentInstaPost] = useState(null);
    const navigate = useNavigate();

    const { reviews } = useSelector((state) => state.fuse.reviews);

    useEffect(() => {
        // navigate back to reviews tab if reviews redux state is empty (because the page got refreshed)
        if (reviews?.length == 0) {
            navigate(-1);
            return;
        }

        // Retrieve data from sessionStorage
        const latestInstaPostId = sessionStorage.getItem("latestInstaPostId");
        const tempInstaItemFiltered = reviews?.filter(
            (item) =>
                item.source == "INSTAGRAM" && item.sourceReviewId == latestInstaPostId
        );

        if (tempInstaItemFiltered?.length > 0) {
            setCurrentInstaPost(tempInstaItemFiltered[0]);
        }
    }, [reviews]);

    return (
        <div className="px-16 pt-12">
            <div className="mb-4">
                <button onClick={() => navigate(-1)}>
                    <div className="flex items-center justify-center w-24 h-24 bg-gray-200 rounded-full hover:bg-gray-300 transition-colors duration-200">
                        <KeyboardBackspaceIcon className="text-gray-600" />
                    </div>
                </button>
            </div>
            <InstagramItem item={currentInstaPost} isNewTab={true} />
        </div>
    );
};

export default InstagramItemNewTab;
